module.exports = __webpack_public_path__ + "static/clickbus-47ff8c92fcc666ced6a7b6f596ac5889.png";